import * as React from "react";
import { PureComponent } from "react";
import { connect } from "react-redux";
import { ErrorMessage } from "../../../external/types/errors";
import { dismissErrorDialog, clearErrorMessage } from "../../actions/errorActions";
import { StoreState } from "../../../external/store/storeState";
import Dialog from "@material-ui/core/Dialog";
import { DialogTitle, DialogContent, DialogActions, Button, Typography } from "@material-ui/core";
import { Dispatch } from "redux";

interface AppWideErrorModalDataProps {
  errorMessage: ErrorMessage;
}

interface AppWideErrorModalDispatchProps {
  dismiss: (errorMessage: ErrorMessage) => void;
  clear: () => void;
}

interface AppWideErrorModalProps extends AppWideErrorModalDataProps, AppWideErrorModalDispatchProps {}

class AppWideErrorModal extends PureComponent<AppWideErrorModalProps> {
  constructor(props: AppWideErrorModalProps) {
    super(props);
  }

  closeDialog = () => {
    this.props.dismiss(this.props.errorMessage);
  };

  clearMessage = () => {
    this.props.clear();
  };

  render() {
    const { errorMessage } = this.props;

    return (
      <Dialog onClose={this.closeDialog} onExited={this.clearMessage} open={errorMessage.visible}>
        <DialogTitle>{errorMessage.title ? errorMessage.title : "Sorry!"}</DialogTitle>
        <DialogContent>
          {errorMessage.message ? (
            errorMessage.message.split("\n").map(s => <Typography style={{ minHeight: "1.5rem" }}>{s}</Typography>)
          ) : (
            <Typography>
              We ran into an issue assisting with your task. Please try again in a minute or contact a support
              representative
            </Typography>
          )}
        </DialogContent>
        <DialogActions>
          <Button variant="outlined" color="default" onClick={this.closeDialog}>
            Dismiss
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}
const mapStateToProps = (state: StoreState): AppWideErrorModalDataProps => {
  return {
    errorMessage: state.errorMessage
  };
};

const mapDispatchToProps = (dispatch: Dispatch): AppWideErrorModalDispatchProps => {
  return {
    dismiss: (errorMessage: ErrorMessage) => {
      dispatch(dismissErrorDialog(errorMessage));
    },
    clear: () => {
      dispatch(clearErrorMessage());
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AppWideErrorModal);
